const defaultState = {
  menu: []
}

const menu = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_MENU_KEY':
      return {
        ...state,
        [action.key]: action.data,
      };

    default:
      return state
  }
}

export default menu;
